import React from 'react';
import { Switch as MuiSwitch, withStyles } from '@material-ui/core';
import { Magnetic as Mi } from "../../styles";
const StyledSwitch = withStyles({
    switchBase: {
        color: Mi.colorWhite,
        '&:hover': {
            backgroundColor: 'transparent'
        },
        '&$checked': {
            color: Mi.colorWhite,
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '& + $track': {
                backgroundColor: Mi.colorGreen05,
                opacity: 1
            },
            '&$disabled + $track': {
                opacity: 0.3
            }
        }
    },
    thumb: {
        color: Mi.colorWhite
    },
    disabled: {},
    checked: {},
    track: {}
})(MuiSwitch);
export const Switch = props => {
    return React.createElement(StyledSwitch, Object.assign({}, props));
};
//# sourceMappingURL=Switch.js.map